import { FormErrors } from "./FormErrors";
import { IMenuItem } from "../../models/IMenuItem";

function getProp<T, K extends keyof T>(obj: T, key: K) {
  return obj[key];
}

function isPresentValue(obj: any): boolean {
  let val = obj;
  if (val && (val as IMenuItem).ID !== undefined) {
    val = (val as IMenuItem).ID;
  }
  return val != null && val != false;
}

export interface IFormValidation<TForm> {
  requiredFields: Array<string>;
  formErrors: FormErrors<TForm>;
  onFormError: (form: FormErrors<TForm>) => void;
  customValidation?: (ers: FormErrors<TForm>, onFormError: (form: FormErrors<TForm>) => void) => boolean;
}

export default function validateForm<TForm extends object>(form: TForm, options: IFormValidation<TForm>) {
  const { requiredFields, onFormError: onFormErrors, formErrors, customValidation } = options;
  let valFailed: boolean = false;
  let errors = { ...formErrors };

  for (let key in form) {
    if (form.hasOwnProperty(key)) {
      let val = getProp(form, key);
      if (!isPresentValue(val) && requiredFields.includes(key)) {
        valFailed = true;
        errors = {
          ...errors,
          [key]: {
            error: true,
            message: "Required",
          },
        };
      }
    }
  }

  if (customValidation && !customValidation(errors, onFormErrors)) {
    valFailed = true;
  }

  if (valFailed) {
    onFormErrors(errors);
    throw new Error("Invalid values found");
  }
}
